import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCenter = function SvgCenter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 325.818c-102.865 0-186.182 83.317-186.182 186.182S409.135 698.182 512 698.182 698.182 614.865 698.182 512 614.865 325.818 512 325.818m416.116 139.637c-21.41-194.095-175.476-348.16-369.57-369.571V0h-93.091v95.884c-194.095 21.41-348.16 175.476-369.571 369.57H0v93.091h95.884c21.41 194.095 175.476 348.16 369.57 369.571V1024h93.091v-95.884c194.095-21.41 348.16-175.476 369.571-369.57H1024v-93.091zM512 837.818c-180.13 0-325.818-145.687-325.818-325.818S331.869 186.182 512 186.182 837.818 331.869 837.818 512 692.131 837.818 512 837.818"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCenter);

export { ForwardRef as default };
